<template>
  <teleport to="body">
    <transition name="backdrop" appear>
      <div class="backdrop" @click="$emit('close')" v-if="open">
      </div>
    </transition>
    <transition name="modal" appear>
        <dialog open v-if="open" class="swiper-container">
            <div>
                <swiper id="swiperBaseImg"
                    :slides-per-view="1"
                    :space-between="100"
                    :pagination="{ clickable: false }"
                    :scrollbar="{ draggable: false }"
                    :autoplay="{delay: 3000}"
                    :loop=true
                    centeredSlides="true"
                    navigation
                    >
                    <swiper-slide v-for="(image, index) in gallery" :key="index">
                        <img class="image__tag" :src="image.lg" alt=""/>
                    </swiper-slide>

                    <div class="swiper-scrollbar"></div>
                </swiper>
            </div>
        </dialog>
    </transition>
  </teleport>
</template>

<script>
import { Swiper, SwiperSlide } from 'swiper/vue';
import SwiperCore, { EffectFade, Autoplay, A11y, Navigation } from 'swiper';

SwiperCore.use([EffectFade, Autoplay, A11y, Navigation ]);

export default {
    components: {
        Swiper,
        SwiperSlide,
    },
    props: {
        open: {
            type: Boolean,
            required: true,
            default: false
        },
        gallery: {
            type: Array,
            required: false,
        },
    },
    emits: ['close'],
    created() {
        
    }
};
</script>

<style>
    #swiperBaseImg{
        min-height: 400px;
    }
    #swiperBaseImg .swiper-pagination-bullets{
        display: none;
    }

    #swiperBaseImg .swiper-scrollbar{
        display: none;
    }

    /* #swiperBaseImg .swiper-button-prev {
        position: fixed;
        left: 30px;
    }

    #swiperBaseImg .swiper-button-next {
        position: fixed;
        right: 30px;
    } */
</style>
<style scoped>
    .swiper-container{
        max-width: 1000px;
        background-color: transparent;
        text-align: center;
    }

    dialog {
        border: 0;
        /* box-shadow: 0 5px 5px rgba(0, 0, 0, 0.2); */
        position: absolute;
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        margin: auto;
        /* width: fit-content;
        height: fit-content; */
        padding: 2rem;
        background-color: transparent;
        z-index: 999;
        transform: none;
    }

    .backdrop {
    content: '';
    position: absolute;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 998;
    /* background: rgba(51, 51, 51, 0.8); */
    background: #000;
    opacity: 0.9;
    cursor: pointer;
    }

    .backdrop-enter-active {
        animation: backdrop ease .4s;
    }

    .backdrop-leave-active {
        animation: backdrop ease .4s reverse;
    }

    @keyframes backdrop {
        0% {
            opacity: 0;
        }
        100% {
            opacity: 0.9;
        }
    }

    .modal-enter-active {
    animation: modal 0.3s ease-out;
    }

    .modal-leave-active {
    animation: modal 0.3s ease-in reverse;
    }

    @keyframes modal {
    from {
        opacity: 0;
        transform: translateY(-50px) scale(0.9);
    }

    to {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
    }

    .actions {
    display: flex;
    -webkit-box-pack: end;
    justify-content: flex-end;
    margin-top: 2rem;
    text-align: right;
    }

    [dir=ltr] .actions > *:not(:last-child) {
    margin-right: 12px;
    }

</style>